var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "gfu-grid__cell gfu-1of1" },
    [
      _c(
        "box",
        [
          _c("h2", { staticClass: "gfu-hd gfu-hd--h2 _ttu" }, [
            _vm._v(
              _vm._s(
                _vm.Resources.SubscriptionManagement.AdfoundNotificationHeader
              )
            ),
          ]),
          _vm._v(" "),
          _c("option-field", {
            staticClass: "_mb-3",
            attrs: {
              "first-column-width": 8,
              options: _vm.basePreferenceOptions,
              "display-name":
                _vm.Resources.SubscriptionManagement
                  .PerformanceMarketingDailyReportFieldLabel,
              name: "model.performanceMarketingDailyReport",
              layout: "columns",
              description:
                _vm.Resources.SubscriptionManagement
                  .PerformanceMarketingDailyReportFieldDescription,
              "data-qa":
                "adfound-notifications:PerformanceMarketingDailyReport",
            },
            on: {
              input:
                _vm.onPerformanceMarketingDailyReportNotificationPreferenceChange,
            },
            model: {
              value: _vm.model.performanceMarketingDailyReport,
              callback: function ($$v) {
                _vm.$set(_vm.model, "performanceMarketingDailyReport", $$v)
              },
              expression: "model.performanceMarketingDailyReport",
            },
          }),
          _vm._v(" "),
          _c("option-field", {
            staticClass: "_mb-3",
            attrs: {
              "first-column-width": 8,
              options: _vm.basePreferenceOptions,
              "display-name":
                _vm.Resources.SubscriptionManagement
                  .PerformanceMarketingRecommendationFieldLabel,
              name: "model.performanceMarketingRecommendation",
              layout: "columns",
              description:
                _vm.Resources.SubscriptionManagement
                  .PerformanceMarketingRecommendationFieldDescription,
              "data-qa":
                "adfound-notifications:PerformanceMarketingRecommendation",
            },
            on: {
              input:
                _vm.onPerformanceMarketingRecommendationNotificationPreferenceChange,
            },
            model: {
              value: _vm.model.performanceMarketingRecommendation,
              callback: function ($$v) {
                _vm.$set(_vm.model, "performanceMarketingRecommendation", $$v)
              },
              expression: "model.performanceMarketingRecommendation",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }